import { publicConfig, urlService } from '@lerna-core';
import { PROF_TEST_UTM } from './coursesProfTest.constants';

export const getProfTestUrlWithUTM = (url = ''): string =>
  `${urlService.normalizeUrl(url)}?${PROF_TEST_UTM.replace(
    '{{region}}',
    publicConfig?.REGION
  )}`;
